// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"61370202","255":"858a1e62","858":"45e0bdaf","943":"6460079e","948":"99441cd2","969":"ad6d3c64"}[chunkId] + ".chunk.css";
};